/**
 * Interface Management API Endpoints
 * Константы endpoints для микросервиса interface-management.
 */

export const InterfaceManagementEndpoints = {
  Grids: "interface-management/grids",
  GridPages: "interface-management/grid-pages",
  GridPageById: "interface-management/grid-pages/{pageId}",
  GridScreens: "interface-management/grid-screens/{screenId}",
  GridWidgets:
    "interface-management/grid-widgets/{widgetId}/rel-grid-screen-widgets/{screenWidgetId}",
  RelGridScreenWidgets: "interface-management/rel-grid-screen-widgets/{id}",

  Guide: "guide",
  MyGuide: "guide/my",
} as const;
